import { GENERIC_FILTERS } from "constants/action-types";

export const fetchFilterValues = (url) => ({
    payload: url,
    type: GENERIC_FILTERS.FETCH.START,
});

export const resetFilterValues = () => ({ type: GENERIC_FILTERS.RESET });
